import { GraphStoreClient } from "graph-store"
import { hydrateGraphStore } from "./hydrate"

// Single MessagePort to the SharedWorker for this tab. ES modules give us
// per-realm singleton semantics — every importer of this module receives the
// same instance, so the tab never opens more ports than it needs.
export const graphStore = new GraphStoreClient()

// Fires once when this module is first imported. Pages and components that
// need the persisted data ready before they query can `await hydrated`;
// most just react to `store-updated`, which hydrate dispatches via the
// graph-store worker once it has parsed the persisted file.
export const hydrated: Promise<void> = hydrateGraphStore(graphStore)
